import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // SEO: Update page title and meta description dynamically
    document.title = "My Money | Personal Wealth Management";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Experience a new dimension of personal wealth management. Track, analyze, and optimize your finances with unparalleled precision and design using My Money.");
    }
  }, []);

  return (
    <main style={{ minHeight: "100vh", padding: "40px 20px" }}>
      {/* Hero Section */}
      <section 
        id="hero-section"
        className="d-flex align-items-center justify-content-center text-center" 
        style={{ minHeight: "65vh", flexDirection: "column" }}
      >
        <div style={{ maxWidth: "700px" }}>
          <h1 
            style={{
              fontSize: "5rem",
              fontWeight: "800",
              letterSpacing: "-0.04em",
              marginBottom: "24px",
              background: "linear-gradient(135deg, var(--text-primary) 0%, var(--primary) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            My Money
          </h1>
          <p style={{ color: "var(--text-secondary)", fontSize: "1.3rem", marginBottom: "48px", lineHeight: "1.6" }}>
            Experience a new dimension of personal wealth management. 
            Track, analyze, and optimize your finances with unparalleled precision and design.
          </p>
          
          <button 
            id="hero-login-button"
            className="btn btn-primary"
            onClick={() => navigate('/login')}
            style={{
              padding: "16px 48px",
              fontSize: "1.2rem",
              borderRadius: "100px",
              fontWeight: "700",
              boxShadow: "0 0 24px var(--primary-glow)",
              letterSpacing: "0.02em",
              transition: "transform 0.2s"
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
          >
            Access Portal
          </button>
        </div>
      </section>

      {/* Features Grid */}
      <section id="features-section" className="container" style={{ marginTop: "20px", paddingBottom: "60px" }}>
        <div className="row g-4">
          <div className="col-md-4">
            <article className="glass-card h-100" style={{ padding: "32px", textAlign: "left" }}>
              <div aria-hidden="true" style={{ fontSize: "2.5rem", marginBottom: "20px", color: "var(--primary)" }}>📊</div>
              <h2 style={{ fontSize: "1.4rem", fontWeight: "700", marginBottom: "12px", color: "var(--text-primary)" }}>Deep Analytics</h2>
              <p style={{ color: "var(--text-secondary)", margin: 0, lineHeight: "1.6", fontSize: "0.95rem" }}>
                Visualize your spending habits with stunning, interactive charts and comprehensive category breakdowns.
              </p>
            </article>
          </div>
          <div className="col-md-4">
            <article className="glass-card h-100" style={{ padding: "32px", textAlign: "left" }}>
              <div aria-hidden="true" style={{ fontSize: "2.5rem", marginBottom: "20px", color: "var(--success)" }}>💼</div>
              <h2 style={{ fontSize: "1.4rem", fontWeight: "700", marginBottom: "12px", color: "var(--text-primary)" }}>Smart Budgets</h2>
              <p style={{ color: "var(--text-secondary)", margin: 0, lineHeight: "1.6", fontSize: "0.95rem" }}>
                Set personalized budgets and receive proactive alerts to ensure you never exceed your financial limits.
              </p>
            </article>
          </div>
          <div className="col-md-4">
            <article className="glass-card h-100" style={{ padding: "32px", textAlign: "left" }}>
              <div aria-hidden="true" style={{ fontSize: "2.5rem", marginBottom: "20px", color: "var(--danger)" }}>🔒</div>
              <h2 style={{ fontSize: "1.4rem", fontWeight: "700", marginBottom: "12px", color: "var(--text-primary)" }}>Secure Ledger</h2>
              <p style={{ color: "var(--text-secondary)", margin: 0, lineHeight: "1.6", fontSize: "0.95rem" }}>
                Your financial data is tightly encrypted and securely stored, giving you complete peace of mind.
              </p>
            </article>
          </div>
        </div>
      </section>
    </main>
  );
};

export default LandingPage;
